export type BrowserNotificationPermission = NotificationPermission | "unsupported";

export type WebPushSyncState =
  | "unsupported"
  | "disabled"
  | "idle"
  | "syncing"
  | "subscribed"
  | "error";

export function isSupportedNotificationPermission(
  value: unknown,
): value is NotificationPermission {
  return value === "granted" || value === "denied" || value === "default";
}

export function getCurrentBrowserNotificationPermission(): BrowserNotificationPermission {
  if (typeof Notification === "undefined") {
    return "unsupported";
  }

  return isSupportedNotificationPermission(Notification.permission)
    ? Notification.permission
    : "unsupported";
}

export function canUseStorage(): boolean {
  return (
    typeof window !== "undefined" && typeof window.localStorage !== "undefined"
  );
}

export function isPushApiSupported(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const hasServiceWorker = "serviceWorker" in navigator;
  const hasPushManager = "PushManager" in window;
  return hasServiceWorker && hasPushManager;
}

export function getPermissionLabel(
  permission: BrowserNotificationPermission,
): string {
  if (permission === "unsupported") {
    return "браузер не поддерживает Notification API";
  }
  if (permission === "granted") {
    return "разрешены";
  }
  if (permission === "denied") {
    return "запрещены";
  }
  return "не запрошены";
}

export function getWebPushStatusLabel(
  state: WebPushSyncState,
  webPushError: string | null,
): string {
  if (state === "unsupported") {
    return "браузер не поддерживает Push API";
  }
  if (state === "disabled") {
    return "выключен";
  }
  if (state === "idle") {
    return "ожидает включения";
  }
  if (state === "syncing") {
    return "синхронизация…";
  }
  if (state === "subscribed") {
    return "подписка активна";
  }
  return webPushError || "ошибка подписки";
}
